/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ClientOauthAccount, ClientPersonExtended } from '@DigitaleDoerfer/digitale-doerfer-api';
import { BaseError } from '../../../shared/errors/Errors';
import { TableColumnSortingDirection, TableSorting } from '../../../shared/views/Table/TableSorting';
import { Pagination } from '../../../shared/services/InMemoryTable.service';

export interface RelatedEntity {
	id: string;
	name: string;
}

export enum EmptyField {
	NONE = 'NONE'
}

export interface ListSearchParams {
	text: string;
	role: string;
	sorting: TableSorting;
	pagination: Pagination;
}

export interface UserState {
	list: {
		users: ClientPersonExtended[];
		searchParams: ListSearchParams;
		loading: boolean;
		error: BaseError | null;
	};
	create: {
		userHasBeenCreated: boolean;
		loading: boolean;
		error: BaseError | null;
	};
	detail: {
		user: ClientPersonExtended | null;
		loading: boolean;
		loadingRoleAssignments: boolean;
	};
	authDetail: {
		authUser: ClientOauthAccount;
		loading: boolean;
	};
}

export const initialUserState: UserState = {
	list: {
		users: [],
		searchParams: {
			text: '',
			role: EmptyField.NONE,
			pagination: {
				page: 0,
				rowsPerPage: 20,
				total: 0
			},
			sorting: { columnId: 'email', direction: TableColumnSortingDirection.ASC }
		},
		loading: false,
		error: null
	},
	create: {
		userHasBeenCreated: false,
		loading: false,
		error: null
	},
	detail: {
		user: null,
		loading: false,
		loadingRoleAssignments: false
	},
	authDetail: {
		authUser: {},
		loading: false
	}
};
